module.exports = __webpack_public_path__ + "profile.241d932611043c7ffc0890711a3e9d4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/profile.svg
// module id = 329
// module chunks = 0